import React, { useState, useEffect } from 'react';

import ValidationUtils from 'application/utils/ValidationUtils';
import { TEXTS } from 'application/pages/AdsPage/renderer/texts';

import { AdCampaignPureType } from '@shared/api/graphql/generated';

import TimeInput, { defaultTimeInputValidator, TIME_PATTERN } from '@zvuk-b2b/react-uikit/ui/TimeInput';
import { InputType } from '@zvuk-b2b/react-uikit/ui/Input';
import DateUtils from '@zvuk-b2b/react-uikit/toolkit/DateUtils';

import styles from './index.module.scss';

export type BroadcastTimesProps = {
  adCampaign?: Pick<AdCampaignPureType, 'id' | 'timingSettings'>;
  dayStartTime?: string;
  dayEndTime?: string;
  setDayStartTime: (value: string | undefined) => void;
  setDayEndTime: (value: string | undefined) => void;
  startElementId?: string;
  endElementId?: string;
  endPlaceholder?: string;
};

const BroadcastTimes = ({
  adCampaign,
  dayStartTime,
  dayEndTime,
  setDayStartTime,
  setDayEndTime,
  startElementId = 'input_start-daytime',
  endElementId = 'input_end-daytime',
  endPlaceholder = '00:00',
}: BroadcastTimesProps) => {
  const [lastValidStartTime, setLastValidStartTime] = useState<string | undefined>(dayStartTime);
  const [lastValidEndTime, setLastValidEndTime] = useState<string | undefined>(dayEndTime);

  const handleDayStartOnBlur = () => {
    if (!ValidationUtils.validateDayTime(dayStartTime || '', TIME_PATTERN)) {
      setDayStartTime(lastValidStartTime);
    }
  };

  const handleDayEndOnBlur = () => {
    if (!ValidationUtils.validateDayTime(dayEndTime || '', TIME_PATTERN)) {
      setDayEndTime(lastValidEndTime);
    }
  };

  const handleDayStartChange = (value: string) => {
    setDayStartTime(value);
  };

  const handleDayEndChange = (value: string) => {
    setDayEndTime(value);
  };

  useEffect(() => {
    if (!adCampaign) {
      return;
    }

    setLastValidStartTime(DateUtils.getFormatTimeFrom(adCampaign.timingSettings.dayStartTime));
    setLastValidEndTime(DateUtils.getFormatTimeFrom(adCampaign.timingSettings.dayEndTime));
  }, [adCampaign?.id]);

  return (
    <div>
      <h4 className={styles.BroadcastTimesSubtitle}>{TEXTS.FORM_BLOCK_TIME_TITLE}</h4>

      <div className={styles.BroadcastTimesDaytime}>
        <TimeInput
          elementId={startElementId}
          label={TEXTS.INPUT_START_TIME_TITLE}
          mask="00:00"
          pattern={TIME_PATTERN}
          placeholder="00:00"
          type={InputType.TEXT}
          value={dayStartTime}
          inputValidator={defaultTimeInputValidator}
          onBlur={handleDayStartOnBlur}
          onChange={handleDayStartChange}
        />

        <TimeInput
          elementId={endElementId}
          label={TEXTS.INPUT_END_TIME_TITLE}
          mask="00:00"
          pattern={TIME_PATTERN}
          placeholder={endPlaceholder}
          type={InputType.TEXT}
          value={dayEndTime}
          inputValidator={defaultTimeInputValidator}
          onBlur={handleDayEndOnBlur}
          onChange={handleDayEndChange}
        />
      </div>
    </div>
  );
};

export default BroadcastTimes;
